export default __webpack_public_path__ + "static/media/supp_volume_fragmentation.f44ca8fb.png";